<template>
    <div>
        管网阀门
    </div>
</template>

<script>
export default {
    name: 'pvalves',
    components: {},
    data() {
        return {}
    },
    mounted(){

    },
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>